import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { radar } from './common/weblog';

import 'normalize.css/normalize.css';
import './assets/style/all.less';
import './global.less';

import { getUrlParam, isStaging, isPre } from '@/utils/util';

if ('production' !== process.env.NODE_ENV || getUrlParam('vconsole') === '1') {
    new (require('vconsole'))();
}

import { init } from './common/init';
init();

Vue.config.productionTip = false;
Vue.config.errorHandler = function (err) {
    // 非staging环境手动上报
    if (!isStaging() && !isPre()) {
        radar && radar.captureException(err);
    }
    console.error(err);
};

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
